import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  width: 100%;
  padding: 0;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  float: left;
  align-items: center;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
